<template>
  <div>
    <div style="min-height: 400px" v-loading="loading2">
    <div class="bl-detail-block" v-if="detail">
      <div class="bl-container">
        <div class="bl-detail-left">
          <div class="v-person-info">
            <div class="v-person-body">
              <span class="v-person-name">{{(detailsInfo.name && detailsInfo.name.content) || detail.personRes.psjName}}</span>
              <span class="v-person-occupation">{{(detailsInfo.post && detailsInfo.post.content) || detail.personRes.psjRank || '--'}}</span>
            </div>
            <div class="v-person-company">{{(detailsInfo.corporateName && detailsInfo.corporateName.content) || detail.personRes.psjComName}}</div>
          </div>
          
          <div style="margin: 12px 0">
            <template v-if="detail.personRes && detail.personRes.questionList">
              <div class="detail-questionTag" v-for="item in detail.personRes.questionList" :key="item.id">
                <span>{{item.aliasName}}：</span>
                <label v-for="aItem in item.answerList" :key="aItem.id">{{aItem.aliasName}}</label>
              </div>
            </template>
          </div>

          <template v-for="(item, key) in detailsInfo">
            <div class="v-color" v-if="(key!='post'&&key!='name'&&key!='corporateName')&&item.content" :key="key"><span>{{item.title}}：</span><span>{{item.content}}</span></div>
          </template>

        </div>
        <div class="bl-detail-right">
          <el-avatar :size="200" :src="detail.personRes.headPortrait || defImage('head')"></el-avatar>
        </div>
      </div>
      <div class="bl-container" style="margin-top: 15px">
        <div class="bl-detail-foot-left">
          <!-- <div class="v-pointer" @click="message2">
            <span class="iconfont iconxiaoxi_weixuanzhong theme-icon-primary-color"></span>
            <span>{{ $t('message') }}</span>
          </div> -->
          <!-- <div class="v-pointer disabled" v-if="detail.invite">
            <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
            <span>{{ $t('finds.invited') }}</span>
          </div>
          <div class="v-pointer" @click="inviteEvent2" v-else>
            <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
            <span>{{ $t('invite') }}</span>
          </div> -->
          <!-- <div class="v-pointer" @click="details(detail)">
            <span class="el-icon-orange theme-icon-primary-color"></span>
            <span>{{ $t('finds.businessCircle') }}</span>
          </div> -->
          <div class="v-pointer" @click="collectEvent2">
            <span class="iconfont theme-icon-primary-color" :class="{'iconshoucang-xuanzhong': detail['collected'], 'iconshoucang': !detail['collected']}"></span>
            <span>{{ detail['collected'] ? $t('collect[1]') : $t('collect[0]') }}</span>
          </div>
        </div>
        <!-- <div class="bl-detail-foot-right">
          <div class="v-share">
            <AddThis publicId="ra-5ee1a595d2a288a7" />
            <span
              class="copy-btn"
              v-clipboard:copy="pageURL"
              v-clipboard:success="onCopy" >{{ $t('Copy Link') }}</span>
          </div>
        </div> -->
      </div>
    </div>
    </div>
    <!-- <div class="bl-find-list" v-loading="loading">
      <div class="bl-container">
        <div class='bl-v-head'>{{$t('finds.wantToSee')}}</div>
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8" v-for="(item, index) in dataList" :key="item.visitorId">
            <VisitorCard 
            :index="index"
            :vData="item" 
            @collect="collectEvent_p" 
            @invite="inviteEvent"
            @details="detailsEvent"
            @msg="msgEvent" />
          </el-col>
        </el-row>
        <div class="list-refresh" @click="handleCurrentChange" v-if="dataList.length != 0"><i class="el-icon-refresh-right"></i><span>{{ $t('change') }}</span></div>
        <hNoData v-if="dataList.length == 0"></hNoData>
      </div>
    </div> -->

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getRecommendedVisitorList, getVisitorDetails } from '@/api/find'
import { eventMixin } from '@/mixins/event.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
// import hNoData from '@/components/hNoData'
// import VisitorCard from '@/components/card/VisitorCard'
// import AddThis from '@/components/AddThis'

export default {
  name: 'findPersonDetail',
  mixins: [eventMixin, inviteMixin],
  components: {
    // VisitorCard,
    // hNoData,
    // AddThis
  },
  data() {
    return {
      loading: false,
      loading2: false,
      query: {
        pageNum: 1,
        pageRows: 9,
        total: 0,
      },
      dataList: [],
      detail: null,
      detailsInfo: {},
      id: this.$route.params.id,
      pageURL: window.location.href
    }
  },
  computed: {
    ...mapGetters(['exhibitorId','subjectType','language']),
    pages: function() {
      if(this.query.total == 0) return 0
      let y = this.query.total%this.query.pageRows
      if(y == 0) {
        return this.query.total/this.query.pageRows
      } else {
        return parseInt(this.query.total/this.query.pageRows) + 1
      }
    }
  },
  mounted() {
    this.pageInit()
  },
  methods: {
    pageInit() {
      this.fetchDetail()
      this.fetchDataList()
    },
    // 更新收藏状态
    updateCollect(status, index) {
      this.dataList[index]['collected'] = status
    },
    // 更新邀约状态
    updateInvite(status, index) {
      this.dataList[index]['invite'] = status
    },
    // 详情收藏
    collectEvent2() {
      this.collectEvent({
        id: this.detail.collectionId,
        deleted: this.detail.collected,
        collectionSubjectType: 'VISITOR',
        collectionSubjectId: this.detail.personRes.id
      }, (status) => {
        this.detail.collected = status
      })
    },
    // 详情邀约
    inviteEvent2() {
      this.inviteEvent({
        projectId: this.detail.personRes.projectId,
        userId: this.detail.personRes.id
      }, (status) => {
        this.detail.invite = status
      })
    },
    // 详情消息
    message2() {
      this.detail.personRes.easemobAccount = this.detail.personRes.imUserName
      this.msgEventPerson(this.detail.personRes, null);
    },
    // 复制成功
    onCopy() {
      this.$notify({
        title: this.$t('tip.success'),
        message: this.$t('Copied'),
        type: 'success'
      })
    },
    // 换一批
    handleCurrentChange() {
      let n = this.query.pageNum
      let status = 'plus'
      // 加
      if (n == 1) {
        status = 'plus'
      } 
      // 减
      if (n == this.pages2) {
        status = 'reduce'
      }
      if (status == 'plus') {
        n += 1
      } else {
        n -= 1
      }
      this.query.pageNum = n
      this.fetchDataList()
    },
    // 获取详情
    fetchDetail() {
      this.loading2 = true
      getVisitorDetails({
        id: this.id,
        showType: 'PERSON_DETAILS'
      }).then(res => {
        return res.data
      }).then(res => {
        if(res.code === 1000) {
          if(res.data.details) {
            res.data.details.forEach((item) => {
              this.detailsInfo[item.keyword] = {
                title: item.showValue.title,
                content: item.showValue.content
              }
            })
          }
          this.detail = res.data
        }
      }).finally(() => {
        this.loading2 = false
      })
    },
    // 获取列表
    fetchDataList() {
      this.loading = true
      // 找客商
      getRecommendedVisitorList({
        ...this.query,
        exhibitorId: this.exhibitorId,
        showType: 'PERSON_LIST'
      }).then(res => {
        return res.data
      }).then(res => {
        if (res.code === 1000) {
          let data = res.data
          this.query.total = data.total || 0
          this.query.pages = data.pages || 0
          this.dataList = data.list || []
        }
      }).finally(() => {
        this.loading = false
      })

    },
    // 找客商 消息
    msgEvent(data, index) {
      data.id = data.visitorId
      data.psjName = data.visitorName
      data.psjRank = data.post
      data.psjComName = data.corporateName
      data.headPortrait = data.headImage
      this.msgEventPerson(data, index);
    },
    // 找客商
    detailsEvent(data) {
      this.pageDetail(data, 'person')
    },
    // 找客商 收藏
    collectEvent_p(params, index, data) {
      params.collectionSubjectId = data.visitorId || data.id
      params.id = data.collectionId
      this.collectEvent(params, index)
    },
  }
}
</script>

<style lang="stylus" scoped>

.disabled {
  background-color: transparent
}
.bl-detail-foot-left{
  float: left;
  overflow: hidden;
}

.bl-detail-foot-right {
  float: right;
}

.list-refresh{
  margin-bottom: 25px;
  text-align: right;
  color: $color-main;
  cursor: pointer

  i{
    margin-right: 8px;
  }
}

</style>
